/* global Set */
// Third-party imports
import _ from 'lodash';
import $ from 'jquery';

class RegionTemplate {
    constructor(child, country, lang, tocart_btn_func) {
        let data = {};

        let dataDiv = $('.sponsorship-data');
        data.countryImage = country.countryImage || country.regionDefaultImage;
        data.mapCenter = this._get_country_name(country.countryName);
        data.comm_msg_nofr = dataDiv.data('sponsorship_no_fr_comm_msg');
        data.personalHeadline = dataDiv.data('personal_hl');
        data.favSubLabel = dataDiv.data('label_sjt');
        data.favActLabel = dataDiv.data('label_act');
        data.corsLangLabel = dataDiv.data('label_cor_lang');
        data.countryImageOverlay = dataDiv.data('img_overlay');
        data.countryImageOverlayAltTxt = dataDiv.data('overlay_alt');
        data.stateOfHeadLine = dataDiv.data('state_hl');
        data.aboutHeadLine = dataDiv.data('about_hl');
        data.statText_water = dataDiv.data('stattext_h2o');
        data.statText_life = dataDiv.data('stattext_life');
        data.statText_edu = dataDiv.data('stattext_edu');
        data.statText_IMR = dataDiv.data('stattext_imr');
        data.statText_income = dataDiv.data('stattext_inc');
        data.blockquote = dataDiv.data('blockquote');
        data.subjectCheck = _.startCase(child.subject);
        data.favPlayCheck = _.startCase(child.fave_play);

        data.selectedChild = child;
        data.countryObject = country;
        data.language = lang;

        data.tocart_btn_func = tocart_btn_func;

        this.data = data;
    }

    build() {
        let data = this.data;
        let personalblock = new PersonalBlock(data);
        let regionblock = new RegionBlock(data);
        let regioninfo = new RegionInfoBlock(data);

        let template =
            personalblock.build() + regionblock.build() + regioninfo.build();

        return template;
    }

    _get_country_name(countryName) {
        // Fix Georgia to point to the country and not to the state in USA
        if (countryName === 'Georgia') {
            countryName = 'Georgia country';
        }
        return _.replace(countryName, / /gm, '+');
    }
}

class Fragment {
    constructor(data) {
        this.data = data;
    }
}

class PersonalBlock extends Fragment {
    constructor(data) {
        super(data);
    }

    build() {
        let data = this.data;
        let videoblock = '';
        let has_video_link = Boolean(data.selectedChild.video_link);
        if (has_video_link) {
            videoblock = this.build_video_block(data);
        } else {
            videoblock = this.build_novideo_block(data);
        }

        let template = `
            <div class="container personalBlock">
                ${videoblock}
            </div>
        `;
        template += '</div>';
        return template;
    }

    build_comm_msg(data) {
        let template = '';
        let country = data.selectedChild.country.toLowerCase().trim();
        let frcomm_countries = new Set([
            'république démocratique du congo',
            'haïti',
            'niger',
            'sénégal',
            'mali',
        ]);

        if (!frcomm_countries.has(country)) {
            template += `
                <li class="personalBlock-textBlock">
                    ${data.comm_msg_nofr}
                </li>
            `;
        }

        return template;
    }

    // This is used inside a video or novideo block
    build_childinfo_listitem(data) {
        let subjectCheck = data.subjectCheck;
        let favPlayCheck = data.favPlayCheck;
        let child = data.selectedChild;
        let listitem = '';

        if (this.data.language === 'zh') {
            let template = `
                我的生日是 ${child.birth_month}月
                ${child.birth_year}日。我今年
                ${child.age} 歲。
                <p>
                    只需要每個月付出39元，您就可以改變我的生命，並給我機會健康快樂地成長。
                </p>
            `;

            return template;
        } else {
            if (subjectCheck !== '' && subjectCheck !== 'None') {
                listitem += `
                    <li class="personalBlock-listItem">
                        ${data.favSubLabel}
                        <span class="personalBlock-listItemInfo">
                            ${subjectCheck}
                        </span>
                    </li>
                `;
            }

            if (favPlayCheck !== '' && favPlayCheck !== 'None') {
                listitem += `
                    <li class="personalBlock-listItem">
                        ${data.favActLabel}
                        <span class="personalBlock-listItemInfo">
                            ${favPlayCheck}
                        </span>
                    </li>
                `;
            }

            if (child.lang !== '') {
                listitem += `
                    <li class="personalBlock-listItem">
                        ${data.corsLangLabel}
                        <span class="personalBlock-listItemInfo">
                            ${child.lang}
                        </span>
                    </li>
                `;
            }

            if (data.language === 'fr') {
                listitem += this.build_comm_msg(data);
            }

            let template = `
                <ul class="personalBlock-list">
                    ${listitem}
                </ul>
            `;

            return template;
        }
    }

    build_video_block(data) {
        let selectedChild = data.selectedChild;
        let personalHeadline =
            this.data.language === 'zh'
                ? `您好，我的名字叫 ${selectedChild.name}。`
                : data.personalHeadline;
        let childinfo_list = this.build_childinfo_listitem(data);
        let child_bio =
            this.data.language === 'zh' ? '' : `<p>${selectedChild.bio}</p>`;
        let child_name_margin =
            this.data.language === 'zh' ? 'style="margin-bottom:10px"' : '';

        let template = `
            <div class="grid grid--middle">
                <div class="grid-1of2 grid-1of1--portable">
                    <div class="video">
                        <video>
                            <source src="${selectedChild.video_link}"
                                    type="video/mp4">
                        </video>
                        <svg class="video-playIcon">
                            <use xlink:href="#icon--video-play"></use>
                        </svg>
                    </div>
                </div>
                <div class="grid-1of2 grid-1of1--portable
                            personalBlock-textBlock">
                    <h3 class="personalBlock-headline js-inject"
                            data-name="${selectedChild.name}"
                            data-country="${selectedChild.country}" 
                            ${child_name_margin}>
                        ${personalHeadline}
                    </h3>
                    ${child_bio}
                    ${childinfo_list}
                    ${data.tocart_btn_func()}
                </div>
            </div>
        `;
        return template;
    }

    build_novideo_block(data) {
        let selectedChild = data.selectedChild;
        let personalHeadline = data.personalHeadline;
        let childinfo_list = this.build_childinfo_listitem(data);
        let child_bio =
            this.data.language === 'zh' ? '' : `<p>${selectedChild.bio}</p>`;
        let child_name_margin =
            this.data.language === 'zh' ? 'style="margin-bottom:10px"' : '';

        let template = `
            <div class="personalBlock-textBlock">
                <h3 class="personalBlock-headline js-inject"
                        data-name="${selectedChild.name}"
                        data-country="${selectedChild.country}"
                        ${child_name_margin}>
                    ${personalHeadline}
                </h3>
                ${child_bio}
                ${childinfo_list}
                ${data.tocart_btn_func()}
            </div>
        `;
        return template;
    }
}

class RegionBlock extends Fragment {
    constructor(data) {
        super(data);
    }

    build() {
        let data = this.data;
        let countryImage = data.countryImage;
        let countryObject = data.countryObject;
        let mapCenter = data.mapCenter;

        let url =
            'https://maps.googleapis.com/maps/api/staticmap' +
            '?size=600x600&amp;' +
            'key=AIzaSyDPpyyNBsUThWttQc2QOzq2xsoyP4XLxAk&amp;' +
            `zoom=${countryObject.mapZoom}&amp;center=${mapCenter}` +
            `&amp;language=${data.language}`;

        let template = `
            <div class="regionBlock" id="regionBlock">
                <div class="regionBlock-info">
                    <div class="regionBlock-title">
                        ${countryObject.countryName}
                    </div>
                    <div class="regionBlock-subtitle">
                        ${countryObject.region}
                    </div>
                </div>
                <div class="regionBlock-map"
                     style="background-image: url(${url})"></div>
                <div class="regionBlock-photo"
                     style="background-image: url(${countryImage})">
                   <img class="regionBlock-tagline"
                        src="${data.countryImageOverlay}"
                        alt="${data.countryImageOverlayAltTxt}">
               </div>
            </div>
        `;

        return template;
    }
}

class RegionInfoBlock extends Fragment {
    constructor(data) {
        super(data);
    }

    build() {
        let data = this.data;
        let blockquote = data.blockquote;
        let selectedChild = data.selectedChild;

        let country_para = this.build_country_paragraph(data);
        let country_stat = this.build_country_stat(data);

        let template = `
            <div class="regionInfoBlock">
                <div class="grid">
                    ${country_para}
                    ${country_stat}
                </div>
                <blockquote class="blockquote--styled js-inject"
                            data-name="${selectedChild.name}">
                    ${blockquote}
                </blockquote>
            </div>
        `;
        return template;
    }

    build_country_paragraph(data) {
        let countryObject = data.countryObject;

        let para2 = '';
        if (countryObject.stateOfParagraph2 !== '') {
            para2 = `
                <p class="regionInfoBlock-info">
                    ${countryObject.stateOfParagraph2}
                </p>
            `;
        }

        let aboutpara2 = '';
        if (countryObject.aboutParagraph2 !== '') {
            aboutpara2 = `
                <p class="regionInfoBlock-info">
                    ${countryObject.aboutParagraph2}
                </p>
            `;
        }

        let template = `
            <div class="grid-1of2 grid-1of1--portable">
                <h3 class="h5 js-inject"
                        data-country="${countryObject.countryName}">
                    ${data.stateOfHeadLine}
                </h3>
                <p class="regionInfoBlock-info">
                    ${countryObject.stateOfParagraph}
                </p>
                ${para2}
                <h3 class="h5 js-inject regionInfoBlock-secondHeadline"
                        data-country="${countryObject.countryName}">
                    ${data.aboutHeadLine}
                </h3>
                <p class="regionInfoBlock-info">
                    ${countryObject.aboutParagraph}
                </p>
                ${aboutpara2}
            </div>
        `;
        return template;
    }

    build_country_stat(data) {
        let countryObject = data.countryObject;
        let statText_water = data.statText_water;
        let statText_life = data.statText_life;
        let statText_IMR = data.statText_IMR;
        let statText_income = data.statText_income;

        let template = `
            <div class="grid-1of2 grid-1of1--portable">
                <div class="statisticBlock">
                    <svg class="statisticBlock-icon">
                        <use xlink:href="#icon--give-clean-water"></use>
                    </svg>
                    <div class="statisticBlock-textWrapper">
                        <p class="statisticBlock-headline h5">
                            ${countryObject.stat_water}
                        </p>
                        <p class="statisticBlock-subtext">
                            ${statText_water}
                        </p>
                    </div>
                </div>
                <div class="statisticBlock">
                    <svg class="statisticBlock-icon">
                        <use xlink:href="#icon--life-expectancy"></use>
                    </svg>
                    <div class="statisticBlock-textWrapper">
                        <p class="statisticBlock-headline h5">
                            ${countryObject.stat_life}
                        </p>
                        <p class="statisticBlock-subtext">
                            ${statText_life}
                        </p>
                    </div>
                </div>
                <div class="statisticBlock">
                    <svg class="statisticBlock-icon">
                        <use xlink:href="#icon--healthcare"></use>
                    </svg>
                    <div class="statisticBlock-textWrapper">
                        <p class="statisticBlock-headline h5">
                            ${countryObject.stat_IMR}
                        </p>
                        <p class="statisticBlock-subtext">
                            ${statText_IMR}
                        </p>
                    </div>
                </div>
                <div class="statisticBlock">
                    <svg class="statisticBlock-icon">
                        <use xlink:href="#icon--income"></use>
                    </svg>
                    <div class="statisticBlock-textWrapper">
                        <p class="statisticBlock-headline h5">
                            ${countryObject.stat_income}
                        </p>
                        <p class="statisticBlock-subtext">
                            ${statText_income}
                        </p>
                    </div>
                </div>
            </div>
        `;

        return template;
    }
}

export function build(selectedChild, countryObject, lang, tocart_btn_func) {
    let template = new RegionTemplate(
        selectedChild,
        countryObject,
        lang,
        tocart_btn_func
    );
    return template.build();
}
